import axios from "./axiosInstance";

export const createNewZone = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post("save-zone", data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const fetchAllZones = async () => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get("get-zone?pagination=false");
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const deleteZoneById = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post("delete-zone", { id });
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateZoneById = async (data, id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`edit-zone/${id}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateZoneArea = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`handle-zone`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const fetchAllQuestions = async () => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get("get-all-questions");
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const tempSaveZoneSettings = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post("temp-save-setting", data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const fetchTempZoneSettings = async () => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get("get-temp-setting");
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const saveZoneSettings = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post("zone-setting/save", data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const fetchPostalCodes = async (city) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `get-postal-codes-by-places-name?placeName=${city}&pagination=false`
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};
